import { motion } from "framer-motion";
import "./Schedule.css";

export default function Schedule() {
  return (
    <motion.section
      className="schedule"
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9 }}
      viewport={{ once: true }}
    >
      <h2>Weekly Training Schedule</h2>
      <p className="subtitle">
        All sessions run <strong>Monday – Sunday</strong> at the
        <strong> ABC – Abbotsford Badminton Club</strong>. Train at your level
        and timing that suits you best.
      </p>

      <div className="table-container">
        <table className="schedule-table">
          <thead>
            <tr>
              <th>Session Type</th>
              <th>Level</th>
              <th>Days</th>
              <th>Time</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan={3} className="type">
                {" "}
                Individual Coaching
              </td>
              <td>Fundamentals</td>
              <td>All Days</td>
              <td>11:00 AM – 10:00 PM</td>
              <td>$45 / hour</td>
            </tr>
            <tr>
              <td>Intermediate</td>
              <td>All Days</td>
              <td>11:00 AM – 10:00 PM</td>
              <td>$45 / hour</td>
            </tr>
            <tr>
              <td>Advanced</td>
              <td>All Days</td>
              <td>11:00 AM – 10:00 PM</td>
              <td>$45 / hour</td>
            </tr>
            <tr className="highlight">
              <td> Group Coaching</td>
              <td>Intermediate</td>
              <td>All Days</td>
              <td>11:00 AM – 10:00 PM</td>
              <td>from $35 / person</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="offers">
        <p>
          {" "}
          <strong>Loyalty Bonus:</strong> Complete 7 sessions and enjoy your 8th
          session <span>FREE</span>!
        </p>
      </div>

      <div className="location">
        <h4>Location</h4>
        <p>
          <strong>ABC – Abbotsford Badminton Club</strong>
          <br />
          18 Flockhart St, Abbotsford VIC 3067
        </p>

        {/* Google Map Embed */}
        <div className="map-container">
          <iframe
            title="SmashKaro Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3152.253160498783!2d145.00498597664672!3d-37.80274433400214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad6418bb3d8e0d3%3A0x22c26c711a7a1f9d!2sAbbotsford%20Badminton%20Club!5e0!3m2!1sen!2sau!4v1700000000000!5m2!1sen!2sau"
            width="100%"
            height="350"
            style={{ border: 0, borderRadius: "10px" }}
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Quick Link for Mobile */}
        <a
          href="https://www.google.com/maps/place/Abbotsford+Badminton+Club/@-37.8027443,145.004986,17z/"
          target="_blank"
          rel="noopener noreferrer"
          className="maps-btn"
        >
          Open in Google Maps
        </a>
      </div>
    </motion.section>
  );
}
